var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('font-awesome-icon',{attrs:{"icon":"spinner","size":"2x","aria-hidden":"true","pulse":"","spin":"","fixed-width":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }